export const typography = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: "14px",
  fontWeight: "400",
  headingWeight: "600",
  lineHeight: "1.5",

  h1: {
    fontSize: "32px",
    fontWeight: "600",
    lineHeight: "1.2"
  },
  h2: {
    fontSize: "24px",
    fontWeight: "600",
    lineHeight: "1.25"
  },
  cardTitle: {
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "1.3"
  },
  body: {
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "1.5"
  },
  caption: {
    fontSize: "13px",
    fontWeight: "400",
    lineHeight: "1.45"
  },
  badge: {
    fontSize: "13px",
    fontWeight: "500",
    lineHeight: "1.3"
  }
};
